import { Minus, Plus, Trash2, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { brl } from "@/lib/api";

export function OrderCart({ cart, setCart, onSend, sending }) {
  const upd = (key, patch) => setCart((c) => c.map((i) => (i.key === key ? { ...i, ...patch } : i)));
  const setQty = (key, qty) => (qty <= 0 ? setCart((c) => c.filter((i) => i.key !== key)) : upd(key, { qty }));
  const total = cart.reduce((s, i) => s + i.price * i.qty, 0);
  return (
    <div className="card-surface" data-testid="order-cart">
      <div className="flex items-center justify-between border-b p-4">
        <p className="font-display font-semibold">Novo pedido</p>
        <span className="text-xs text-muted-foreground">{cart.reduce((s, i) => s + i.qty, 0)} item(ns)</span>
      </div>
      <ul className="divide-y max-h-[35vh] overflow-y-auto">
        {cart.map((i) => (
          <li key={i.key} className="flex items-start gap-2 p-3 text-sm" data-testid={`order-cart-item-${i.product_id}`}>
            <div className="min-w-0 flex-1">
              <p className="font-medium">{i.name}</p>
              <input value={i.notes} onChange={(e) => upd(i.key, { notes: e.target.value })} placeholder="+ observação"
                className="w-full bg-transparent text-xs text-amber-600 dark:text-amber-400 outline-none" data-testid={`order-cart-notes-${i.product_id}`} />
            </div>
            <Button size="icon" variant="outline" className="h-8 w-8" onClick={() => setQty(i.key, i.qty - 1)} data-testid={`order-cart-dec-${i.product_id}`}>{i.qty === 1 ? <Trash2 className="h-3 w-3" /> : <Minus className="h-3 w-3" />}</Button>
            <span className="w-6 text-center font-mono" data-testid={`order-cart-qty-${i.product_id}`}>{i.qty}</span>
            <Button size="icon" variant="outline" className="h-8 w-8" onClick={() => setQty(i.key, i.qty + 1)} data-testid={`order-cart-inc-${i.product_id}`}><Plus className="h-3 w-3" /></Button>
            <span className="w-20 text-right font-mono">{brl(i.price * i.qty)}</span>
          </li>
        ))}
        {!cart.length && <li className="p-6 text-center text-sm text-muted-foreground">Toque nos produtos para montar o pedido.</li>}
      </ul>
      <div className="border-t p-4">
        <Button className="w-full h-12 text-base" disabled={!cart.length || sending} onClick={onSend} data-testid="order-send-btn"><Send className="h-4 w-4 mr-2" />Pedir · {brl(total)}</Button>
      </div>
    </div>
  );
}
